import React from 'react';
import HomeSubSaveNavbar from '../HomeSubSaveNavbar';
import HomeSubSaveInfo from '../HomeSubSaveInfo';

const HomeSubSaveWrap = (props) => {
  const { form, subPageSave, setData, onSubmit } = props;

  return (
    <div className="home-sub-save-wrap">
      {/* 하단 네브바 */}
      <HomeSubSaveNavbar onSubmit={onSubmit} />

      {/* 서브 페이지 정보 */}
      <HomeSubSaveInfo
        form={form}
        setData={(data) =>
          setData({
            path: ['subPageSave', ...data.path],
            value: data.value,
          })
        }
        pageInfo={subPageSave}
      />
    </div>
  );
};

export default HomeSubSaveWrap;
